export const api_url = 'https://optobot.herokuapp.com';
// export const api_url = 'http://localhost:3000';
